var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneOutlet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.83,6.17 8.33,6.17 8.33,1.56 2.25,1.56 2.25,1.06 8.83,1.06  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.99,8.41 10.49,8.41 10.49,6.42 6.32,6.42 6.32,8.41 5.82,8.41 5.82,5.92 10.99,5.92  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.37,14.99c-1.54,0-2.79-1.25-2.79-2.79S4.83,9.4,6.37,9.4c1.54,0,2.79,1.25,2.79,2.79S7.91,14.99,6.37,14.99 z M6.37,9.9c-1.26,0-2.29,1.03-2.29,2.29s1.03,2.29,2.29,2.29s2.29-1.03,2.29-2.29S7.63,9.9,6.37,9.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.37,
    cy: 12.2,
    r: 1.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.37,13.98c-0.99,0-1.79-0.8-1.79-1.79s0.8-1.79,1.79-1.79s1.79,0.8,1.79,1.79S7.35,13.98,6.37,13.98z  M6.37,10.51c-0.93,0-1.69,0.76-1.69,1.69c0,0.93,0.76,1.69,1.69,1.69c0.93,0,1.69-0.76,1.69-1.69C8.06,11.27,7.3,10.51,6.37,10.51 z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.99,13.95v-1.91h-0.71v-0.25h1.72v0.25h-0.72v1.91H10.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.28,13.95v-2.16h0.82c0.14,0,0.25,0.01,0.33,0.02c0.11,0.02,0.19,0.05,0.27,0.1 c0.07,0.05,0.13,0.12,0.18,0.21c0.04,0.09,0.06,0.19,0.06,0.3c0,0.18-0.06,0.34-0.18,0.47c-0.12,0.13-0.33,0.19-0.63,0.19h-0.56 v0.88H12.28z M12.57,12.82h0.56c0.18,0,0.32-0.03,0.39-0.1c0.08-0.07,0.12-0.17,0.12-0.29c0-0.09-0.02-0.17-0.07-0.23 c-0.05-0.06-0.11-0.11-0.18-0.13c-0.05-0.01-0.14-0.02-0.27-0.02h-0.55V12.82z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.32,4.61V2.7H10.6V2.44h1.72V2.7h-0.72v1.91H11.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.61,4.61V2.44h0.82c0.15,0,0.25,0.01,0.33,0.02c0.11,0.02,0.2,0.05,0.27,0.1 c0.07,0.05,0.13,0.12,0.17,0.21c0.04,0.09,0.07,0.19,0.07,0.3c0,0.18-0.06,0.34-0.18,0.47c-0.12,0.13-0.33,0.19-0.63,0.19H12.9 v0.88H12.61z M12.9,3.47h0.56c0.18,0,0.32-0.03,0.39-0.1s0.12-0.17,0.12-0.29c0-0.09-0.02-0.17-0.07-0.23 c-0.05-0.06-0.11-0.11-0.18-0.13c-0.05-0.01-0.14-0.02-0.27-0.02H12.9V3.47z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneOutlet);
export default __webpack_public_path__ + "static/media/TelephoneOutlet.5eb9ea8c1f39141fb196a6cad7e56661.svg";
export { ForwardRef as ReactComponent };